import { axiosRequest } from '@planbord/axios-request';
import { useQuery } from '@tanstack/vue-query';
import { SelectOption } from '@planbord/shared/models';

export const useListPersonSelectOptions = () => {
  const baseUrl = '/api';

  return useQuery<SelectOption[]>({
    queryKey: ['listPersonSelectOptions'],
    queryFn: () =>
      axiosRequest
        .get(`${baseUrl}/listPersonSelectOptions`)
        .then((res) => res.data),
    // Use the cache for 60 minutes
    staleTime: 60 * 60000,
  });
};
